import styled from 'styled-components'

export const PrivacyStyled = styled.div`
  margin-top: -100px;
`
